module.exports = __webpack_public_path__ + "static/media/madhucon3.13e086aa.png";